import {array, lazy, object, string} from 'yup'

import type {AppConfig} from '../contexts/ConfigContext'
import {FieldName, routeDestinationPrefixName, routeReturnName, routeSourceName} from './fieldNames'

/**
 * Схема валидации фронтовых компонентов формы заказа.
 * @param taxiClass Вертикаль, которой соответствует схема
 * @param i18n Функция для получения перевода по ключу
 * @param config Конфиг приложения
 * @returns Правила валидации
 */
export const getFormValidationSchema = (taxiClass: string, i18n: (key: string) => string, config: AppConfig) => {
  const validationSchemas = {
    ndd_self_pickup: object({
      [FieldName.Ndd]: object({
        route: object({
          source: object({
            pickupPoint: object().required(i18n('validation.required')),
            phone: string()
              .required(i18n('validation.required'))
              .test('phone', i18n('validation.phone.invalid'), config.checkIsValidPhone),
          }),
          destination: object({
            pickupPoint: object().required(i18n('validation.required')),
            phone: string()
              .required(i18n('validation.required'))
              .test('phone', i18n('validation.phone.invalid'), config.checkIsValidPhone),
          }),
        }),
      }),
    }),
    DEFAULT: object({
      [FieldName.Route]: lazy(obj =>
        object({
          ...Object.keys(obj || {}).reduce((acc, key) => {
            acc[key] = key.startsWith(routeDestinationPrefixName) // адреса итерируются через значение в ключе: destination_${iteration}
              ? object({
                  address: object({
                    title: string().required(i18n('validation.required')),
                  }),
                })
              : undefined

            return acc
          }, {}),
          [routeSourceName]: object({
            address: object({
              title: string().required(i18n('validation.required')),
            }),
          }),
          [routeReturnName]: object({
            address: object({
              title: string(),
              // валидируем телефон, только если выбран адрес
              phone: string().when('title', {
                is: (title?: string) => {
                  return typeof title === 'string' && title.length > 0
                },
                then: string()
                  .required(i18n('validation.required'))
                  .test('phone', i18n('validation.phone.invalid'), config.checkIsValidPhone),
              }),
            }),
          }),
        }),
      ),
      [FieldName.Contacts]: array(
        object({
          phone: string()
            .required(i18n('validation.required'))
            .test('phone', i18n('validation.phone.invalid'), config.checkIsValidPhone),
        }),
      )
        .default([{phone: ''}, {phone: ''}])
        .required(i18n('validation.required')),
    }),
  }

  return validationSchemas[taxiClass] ?? validationSchemas.DEFAULT
}
